import React from 'react'
import { Box, SearchInput } from '@workwhile/ui'
import { useRulesContextValue } from '../context/RulesProvider'

export const RulesSearch = () => {
  const {
    state: { searchInput },
    actions: { setSearchInput },
  } = useRulesContextValue()

  return (
    <Box mb={3} maxWidth={['100%', '100%', '100%', '50%']}>
      <SearchInput
        keyword={searchInput}
        setKeyword={setSearchInput}
        placeholder="Search by ID or reference"
        block
        clearable={false}
      />
    </Box>
  )
}
